import { Dispatch, SetStateAction, useState } from "react";
import CustomButtonSimple from "../../../components/CustomMiscellaneous/CustomButtonSimple";
import { PropDisplay } from "../../../components/PropDisplay";
import { IEntrega, IPeca, IPecaParaEntrega } from "../../Obras/newObra/IObra";
import EditIcon from '@mui/icons-material/Edit';
import { PecaDisplay } from "./PecaDisplay";
import { BackArrow } from "../../../components/CustomMiscellaneous/BackArrow";
import { useLocation, useNavigate } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import EmailIcon from '@mui/icons-material/Email';
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { genericDelete } from "../../../services/api.service";
import { ConfirmationModal } from "../../Common/Modals/ConfirmationModal";
import { EmailClientmodal } from "./EmailClientModal";




export function EntregasDisplay({ entrega, setEditing, refetchEntrega }: { entrega: IEntrega, setEditing: Dispatch<SetStateAction<boolean>>, refetchEntrega: () => void }) {

    const location = useLocation();
    const navigate = useNavigate();
    const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = useState(false);
    const [notifyClientModalOpen, setNotifyClientModalOpen] = useState(false);

    const goBackToObra = () => {
        const splittedRoute = location.pathname.split('/');
        const route = [splittedRoute[0], splittedRoute[1], splittedRoute[2]].join('/');
        console.log("Going back to route: ", route);
        navigate(route);
    }

    const deleteMutation = useMutation(genericDelete(location.pathname), {
        onSuccess: () => {
            toast.success("Entrega eliminada com sucesso");
            navigate(-1);
        },
        onError: () => {
            toast.error("Erro ao eliminar obra");
        }
    });

    return (
        <>
            <EmailClientmodal refetch={refetchEntrega} entregaId={entrega.id} isOpen={notifyClientModalOpen} close={() => setNotifyClientModalOpen(false)} />
            <ConfirmationModal isOpen={deleteConfirmationModalOpen} text={"Eliminar a entidade?"} onConfirm={() => deleteMutation.mutate(undefined)} onCancel={() => setDeleteConfirmationModalOpen(false)} />
            <div>
                <BackArrow onClick={() => goBackToObra()} />
                <div className="border rounded-md shadow-md p-8 px-16 text-sm m-10">
                    <h2 className="font-bold text-xl mb-4">Entrega {entrega.id}</h2>
                    <PropDisplay prop={"Data entrega"} value={(entrega.realDeliveryDate as unknown) as string} />
                    <PropDisplay prop={"Data entrega (para colaboradores)"} value={(entrega.publicDeliveryDate as unknown) as string} />
                    <PropDisplay prop={"Data fim de produção"} value={(entrega.productionReadyDate as unknown) as string} />
                    <PropDisplay prop={"Duração (h)"} value={entrega.duration.toString()} />
                    <PropDisplay prop={"Duração"} value={entrega.durationInDays} />
                    <PropDisplay prop={"Data início de produção"} value={entrega.startingDate} />
                    <PropDisplay prop={"Percentagem da obra"} value={`${entrega.percentage} %`} />
                    <PropDisplay prop={"Cliente notificado por email"} value={`${entrega.clientNotified ? 'Sim' : 'Não'}`} />

                    <div className="mt-5">
                        <div className="font-bold mb-2">Lista de peças</div>
                        {entrega.pecasParaEntrega?.map((p: IPecaParaEntrega, idx: number) =>
                            <PecaDisplay key={idx} peca={p} />
                        )}
                    </div>

                    <div className="flex justify-end mt-2">
                        <CustomButtonSimple text={"Editar"} Icon={EditIcon} onClick={setEditing} />
                        <CustomButtonSimple text={"Eliminar"} Icon={DeleteIcon} onClick={() => setDeleteConfirmationModalOpen(true)} />
                        <CustomButtonSimple text={"Notificar cliente"} Icon={EmailIcon} onClick={() => setNotifyClientModalOpen(true)} />
                    </div>
                </div>
            </div>
        </>

    )



}